import { Alert } from '@akin-home/alerts';
import {
  getAlertQuery,
  listAllAlertsByHabitatQuery,
} from '@akin-home/alerts/frontend';
import { createQueryKeySet } from '@akin-home/utils/react-query';
import { useQuery } from 'react-query';

export * from './useGetAlert';

export const alertQueryKeys = createQueryKeySet({
  key: 'alerts',
});

export const useListAllAlertsByHabitatQuery = (
  params: {
    habitatID: string;
    filter?: { from?: string; to?: string; goal_id?: string };
  },
  options?: any
) =>
  useQuery(
    alertQueryKeys.list(params),
    async () => {
      const items = await listAllAlertsByHabitatQuery(
        params.habitatID as string,
        params.filter
      );

      return items.map((item: any) => ({
        ...item,
        checklist: item.checklist || [],
        start: new Date(item.start),
      }));
    },
    {
      enabled: !!params?.habitatID,
      ...options,
    }
  );

export const useListAlertsForGoal = (habitatID: string, goal_id?: string) => {
  return useListAllAlertsByHabitatQuery(
    { habitatID, filter: { goal_id } },
    { enabled: !!goal_id }
  );
};

export const useGetAlertQuery = (
  id: string | undefined,
  options?: UseQueryOptions
) =>
  useQuery(
    alertQueryKeys.detail(id),
    async () => {
      const item = await getAlertQuery(id as string);

      return {
        ...item,
        start: new Date(item.start),
      } as Alert;
    },
    { enabled: !!id, ...options }
  );
